module.exports = __webpack_public_path__ + "img/sec4_4_.8371816a.png";